export default __webpack_public_path__ + "static/media/trend-positive.575a6f4b.svg";